import { render, staticRenderFns } from "./OrderTmsForm.vue?vue&type=template&id=2e0b1eb6&"
import script from "./OrderTmsForm.vue?vue&type=script&lang=js&"
export * from "./OrderTmsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e0b1eb6')) {
      api.createRecord('2e0b1eb6', component.options)
    } else {
      api.reload('2e0b1eb6', component.options)
    }
    module.hot.accept("./OrderTmsForm.vue?vue&type=template&id=2e0b1eb6&", function () {
      api.rerender('2e0b1eb6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/gift/orderMgt/modules/OrderTmsForm.vue"
export default component.exports